import { render, staticRenderFns } from "./CourseTestToolbar.vue?vue&type=template&id=395c36c4&scoped=true"
import script from "./CourseTestToolbar.vue?vue&type=script&lang=ts"
export * from "./CourseTestToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c36c4",
  null
  
)

export default component.exports